import { Component, OnInit, ViewChild } from '@angular/core';
import { trigger, transition, useAnimation, style } from '@angular/animations';
import { fadeInDown } from 'ng-animate';
import { ApiDataServices } from '../../../../services/apiservices/api.services';
import { ApiurlsService } from '../../../../services/api-urls/apiurls.service';
import { HttpClient } from '@angular/common/http';
import { StockList } from '../../../../model/stock-model';
import { MatSort } from '@angular/material';
import { ApirequestService } from '../../../../services/apirequest/apirequest.service';


@Component({
  selector: 'hybse-admin-dashboardwidgets',
  templateUrl: './dashboardwidgets.component.html',
  styleUrls: ['./dashboardwidgets.component.css'],
  animations: [
    trigger('fadeInDown', [transition('* => *', useAnimation(fadeInDown, {
      params: {
        timing: 1,
        a: '-50px'
      }
    }))])
  ]
})
export class DashboardwidgetsComponent implements OnInit {
  showLoader: boolean = true;
  fadeInDown: any;
  public stockList: StockList[];
  displayedColumns: string[] = ['companyName', 'stockName', 'priceCurrent', 'volume'];
  public gainLoss: number;
  public color: string;
  public IBOList: any[];
  public marketList: any[];
  public kycList: any[];
  public errorMessage: string;
  public kycErrorMessage: string;
  public marketErrorMessage: string;
  public stockErrorMessage: string;
  public iboErrorMessage: string;

  @ViewChild(MatSort) sort: MatSort;

  constructor(public _http: HttpClient, private _urls: ApiurlsService, private _api: ApirequestService) {
  }

  ngOnInit() {
    this.getDemoStockList();
    this.getIBOList();
    this.getMarketList();
    this.getKYCList();
  }

  public getDemoStockList(): void {
    this._http.post(this._urls.demoStockListUrl, {}).subscribe((res) => {
      if (res['data']) {
        this.stockList = res['data'];
        this.onGainAndLossCalc();
      } else {
        this.stockErrorMessage = res['error']['Error Description'];
      }
    });
  }

  public onGainAndLossCalc(): void {
    this.stockList.forEach((data) => {
      let value = ~~data.volume;
      data.volume = value;
      let gainAndLoss = (+data.priceCurrent - +data.priceClose) / +data.priceClose;
      let result = +gainAndLoss * 100;
      data.gainLoss = +result.toFixed(2);
    });
  }


  getIBOList() {
    this._api.fetchApiData(this._urls.listIBOUrl, {}, 'get').subscribe(
      (data: any) => {
        let resSucc = data.data.iboList;
        let resError = data.error;
        if (resSucc != '') this.IBOList = resSucc;
        if (resError != '') {
          this.iboErrorMessage = resError['Error Description'];
        }
      },
      error => { },
      () => {
        // this.showLoader = false;
      }
    )
  }

  getMarketList() {
    this._api.fetchApiData(this._urls.marketListUrl, {}, 'get').subscribe(
      (data: any) => {
        let resSucc = data.data;
        let resError = data.error;
        if (resSucc != '') this.marketList = resSucc.marketList;
        if (resError != '') {
          this.marketErrorMessage = resError['errorDescription'];
        }
      },
      error => {

      },
      () => {
        // this.showLoader = false;
      }
    )
  }

  getKYCList() {
    this.showLoader = true;
    this.kycList = [];
    this._api.fetchApiData(this._urls.KycListUrl, {}).subscribe(
      (data: any) => {
        let resSucc = data.data;
        let resError = data.error;
        if (resSucc != '') this.kycList = resSucc.kycList;
        if (resError != '') {
          this.kycErrorMessage = resError.errorDescription;
        }
      },
      (error) => { },
      () => {
        this.showLoader = false;
      })
  }
}



// WEBPACK FOOTER //
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/app/components/pages/dashboard/dashboardwidgets/dashboardwidgets.component.ts